import React from "react";
import { Context } from "./context";
import { Header } from "./boxes/Header";
import { DetailRows } from "./boxes/DetailRows";
import { Actions } from "./boxes/Actions";
import { Modals } from "./boxes/Modals";
import { LinkToMainProviderDetails } from "./shared/LinkToMainProviderDetails";

/**
 * @param {{
 *  id: number;
 *  onClose: () => void;
 *  refetchAppointments?: () => void;
 * }} param0
 */
export function Appointment({ id, onClose, refetchAppointments }) {
  const contextValue = {
    id,
    onClose,
    refetchAppointments: refetchAppointments || (() => {}),
    modals: {
      fee: Modals.Fee.useHandler(),
      cancelNotification: Modals.CancelNotification.useHandler(),
      noShowNotification: Modals.NoShowNotification.useHandler(),
      confirmCancel: Modals.ConfirmCancel.useHandler(),
      confirmNoShow: Modals.ConfirmNoShow.useHandler(),
      checkin: Modals.Checkin.useHandler(),
    },
  };

  return (
    <Context.Provider value={contextValue}>
      <Header />
      <div className="newPopupContent">
        <DetailRows />
        <LinkToMainProviderDetails />
        <Actions />
      </div>
      <Modals />
    </Context.Provider>
  );
}
